import { Select, notification } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UserContext } from '../../context/UserContext';
import { getDoctor } from "../../utils/api-lists/doctor.api";
import AddClientImage from "../AddClientImage";
import LoadingSpinner from "../AntCostomComponents/LoadingSpinner";
import Input from "../Input";
import { Section, Wrapper } from "./DoctorProfile.styles";


const DoctorProfile = () => {
    const userContext = useContext(UserContext);
    const [doctor, setDoctor] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const {t, i18n} = useTranslation('common');
    const currentLanguage = localStorage.getItem('language') || 'en';
    const [language, setLanguage] = useState(currentLanguage);

    useEffect(() => {
        setLoading(true);
        const user = userContext.user;
        if (user === null) return;
        console.log('user ' + JSON.stringify(user));

        getDoctor(user.id).then((data) => {
            setDoctor(data);
            setLoading(false);
        }).catch((err) => {
            setError(err);
            setLoading(false);
        });
    }, [userContext.user]);

    const setLanguageUI = (language) => {
        console.log("Setting language to:", language);
        i18n.changeLanguage(language);
        setLanguage(language);
        localStorage.setItem('language', language);
    }

    const handleImageChange = (newImageUrl) => {
        userContext.updateUserProfile({profile_picture: newImageUrl});
    }

    const languageOptions = [
        {value: 'en', label: 'EN'},
        {value: 'it', label: 'IT'},
        {value: 'es', label: 'ES'},
        {value: 'az', label: 'AZ'}
    ];

    if (error) {
        notification.error({
            message: t("error"),
            description: t("error_general"),
            placement: "top",
            duration: 3,
        });
    }


    if (loading) {
        return <LoadingSpinner/>;
    }

    return (
        <Wrapper>
            <Section>
                <h4>{t("profile_photo")}</h4>
                <div>
                    <AddClientImage
                        showText={false}
                        imgUrl={userContext.user.profile_picture}
                        doctorId={doctor.id}
                        onImageChange={handleImageChange}
                    />
                </div>
            </Section>
            <Section>
                <h4>{t("organization")}</h4>
                <Input
                    type="text"
                    name="organization"
                    value={doctor.organization_name}
                    placeholder={t("organization")}
                    disabled={true}
                />
            </Section>
            <Section>
                <h4>{t("name")}</h4>
                <Input
                    type="text"
                    name="name"
                    value={doctor.first_name}
                    placeholder={t("first_name")}
                    disabled={true}
                />
            </Section>
            <Section>
                <h4>{t("surname")}</h4>
                <Input
                    type="text"
                    name="last_name"
                    value={doctor.last_name}
                    placeholder={t("last_name")}
                    disabled={true}
                />
            </Section>
            <Section>
                <h4>{t("email_address")}</h4>
                <Input
                    type="email"
                    name="email"
                    value={doctor.email}
                    placeholder={t("email")}
                    disabled={true}
                />
            </Section>
            <Section>
                <h4>{t("password")}</h4>
                <button
                    onClick={() => {
                        navigate("/change-password");
                    }}
                    type="submit"
                    className="btn btn-2 btn-align-right"
                >
                    {t("change_password")}
                </button>
            </Section>
            <Section>
                <h4>{t("language-selector.label")}</h4>

                <Select
                    defaultValue={currentLanguage}
                    options={languageOptions}
                    value={currentLanguage}
                    onChange={(selectedOption) => setLanguageUI(selectedOption)}
                />
            </Section>
        </Wrapper>
    );
};

export default DoctorProfile;